// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"28e25121","252":"8a983ac9","314":"48fe2d27","546":"d2780044","594":"7bd53892","596":"088c3269","606":"6048e658","823":"6e6c3157"}[chunkId] + ".chunk.js";
};